(() => {
  'use strict';
  if (window.ProTierImageRepair) return;
  const configNode = document.getElementById('pt-hi-tech-image-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  if (config.enabled !== true) return;
  const storeOrigin = config.storeOrigin || location.origin;
  const storeHostname = new URL(storeOrigin).hostname;
  const images = new Map(Object.entries(config.images || {}));
  const ownerHandles = new Map(Object.entries(config.handles || {}));
  const bundles = new Map(Object.entries(config.bundles || {}));
  const attributes = ['src', 'srcset', 'data-src', 'data-srcset', 'data-image', 'data-hero', 'data-pt-image'];
  const selector = 'img,source,[data-src],[data-image],[data-pt-image]';
  function resolve(value, handle = '') {
    if (typeof value !== 'string' || !value) return value;
    let url;
    try { url = new URL(value, storeOrigin); } catch { return value; }
    if (url.hostname !== storeHostname && url.hostname !== 'cdn.shopify.com') return value;
    if (ownerHandles.has(handle)) return new URL(ownerHandles.get(handle), storeOrigin).href;
    const filename = decodeURIComponent(url.pathname.split('/').pop() || '');
    if (bundles.has(handle) && /^hi-tech-16x16-edgeless-(blue|green|yellow)-transparent/.test(filename)) return new URL(bundles.get(handle), storeOrigin).href;
    return images.has(filename) ? new URL(images.get(filename), storeOrigin).href : value;
  }
  function handleFor(node) {
    const owner = node.closest('[data-product-handle]');
    if (owner) return owner.getAttribute('data-product-handle') || '';
    const card = node.closest('.ptm__card,.ptbr__card,.pt-master__card,.pt-static-rec,product-card');
    const link = card && card.querySelector('a[href*="/products/"]');
    if (link) {
      try { return new URL(link.href, location.origin).pathname.split('/products/')[1]?.split('/')[0] || ''; } catch { return ''; }
    }
    if (node.closest('.ptm__gallery,[data-product-media-gallery]')) return config.currentHandle || '';
    return '';
  }
  function repair(node) {
    if (!(node instanceof Element) || node.closest('[data-pt-authentic-components],[data-pt-approved-interior-photo],[data-pt-approved-kit-photo]')) return;
    const handle = handleFor(node);
    for (const attribute of attributes) {
      const value = node.getAttribute(attribute);
      if (!value) continue;
      const next = attribute.endsWith('srcset')
        ? value.split(',').map(part => { const bits = part.trim().split(/\s+/); bits[0] = resolve(bits[0], handle); return bits.join(' '); }).join(', ')
        : resolve(value, handle);
      if (next !== value) node.setAttribute(attribute, next);
    }
  }
  function scan(root) {
    if (!(root instanceof Element) && root !== document) return;
    if (root instanceof Element && root.matches(selector)) repair(root);
    root.querySelectorAll(selector).forEach(repair);
  }
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') repair(record.target);
      else record.addedNodes.forEach(scan);
    }
  });
  observer.observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: attributes});
  window.ProTierImageRepair = Object.freeze({resolve});
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();



